export default __webpack_public_path__ + "static/media/convenient.538db728.webp";